<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-container>
      <v-row justify="center">
        <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
          <material-card
            v-if="selectedItem"
            :title="$t('components.portal.plan_notifications.delete')"
            :color="$vuetify.theme.themes.light.error"
            icon="delete"
          >
            <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
            <v-card-actions>
              <v-btn color text @click="dialogs.delete = false">
                {{
                $t("globals.cancel")
                }}
              </v-btn>
              <v-btn color="error" text @click="tryDelete">
                {{
                $t("globals.delete")
                }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog v-model="dialogs.deactivate" scrollable persistent max-width="400">
          <material-card
            v-if="selectedItem"
            :title="$t('views.portalnotifications.deactivate_notification')"
            :color="$vuetify.theme.themes.light.error"
            icon="toggle_off"
          >
            <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
            <v-card-actions>
              <v-btn
                :disabled="saving"
                text
                @click="dialogs.deactivate = false"
              >{{ $t("globals.cancel") }}</v-btn>
              <v-btn
                color="error"
                :loading="saving"
                @click="activate(false)"
              >{{ $t("globals.deactivate") }}</v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog v-model="dialogs.activate" scrollable persistent max-width="400">
          <material-card
            v-if="selectedItem"
            :title="$t('views.portalnotifications.activate_notification')"
            :color="$vuetify.theme.themes.light.success"
            icon="toggle_on"
          >
            <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
            <v-card-actions>
              <v-btn
                :disabled="saving"
                text
                @click="dialogs.activate = false"
              >{{ $t("globals.cancel") }}</v-btn>
              <v-btn
                color="success"
                :loading="saving"
                @click="activate(true)"
              >{{ $t("globals.activate") }}</v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1200">
          <material-card
            v-if="selectedItem"
            :title="$t(formTitle)"
            :icon="formIcon"
            :color="formColor"
          >
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-container fluid>
                  <v-row>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        v-model="selectedItem.Name"
                        :label="$t('globals.name')"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="12" md="12" lg="12">
                      <trans-texteditor
                        v-model="selectedItem"
                        :label="$t('views.portalnotifications.content')"
                        field="Html"
                        :dialog="dialogs.edit"
                      ></trans-texteditor>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <trans-select
                        :item="selectedItem"
                        propertyName="PopupBehaviour"
                        :items="behaviours"
                        :label="$t('views.portalnotifications.related_activity')"
                        :rules="[$rules.required]"
                        class="required"
                      ></trans-select>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <v-checkbox
                        v-model="selectedItem.Active"
                        :label="$t('globals.active')"
                      ></v-checkbox>
                    </v-col>
                    <!-- <v-col
                      xs="12"
                      sm="12"
                      md="6"
                      lg="6"
                      v-if="selectedItem.Active===true"
                    >
                      <display-period-picker
                        :periods="periods"
                        v-model="selectedItem"
                        :label="$t('views.portalnotifications.period')"
                        :rules="[ $rules.required ]"
                      ></display-period-picker>
                    </v-col>-->
                    <template v-if="selectedItem.Active===true">
                      <v-col xs="12" sm="6" md="4" lg="3">
                        <trans-select
                          :item="selectedItem"
                          propertyName="PopupPeriod"
                          :items="periods"
                          :label="$t('views.portalnotifications.period')"
                          :rules="[ $rules.required ]"
                          class="required"
                        ></trans-select>
                      </v-col>
                      <template
                        v-if="selectedItem.PopupPeriod && selectedItem.PopupPeriod.Id === periods.filter(o=>o.Name === 'DateRange')[0].Id"
                      >
                        <v-col xs="12" sm="6" md="4" lg="3">
                          <pbas-date-picker
                            :value="selectedItem.From"
                            @update-date="selectedItem.From = $event"
                            :rules="[ $rules.required ]"
                            :label="$t('views.portalnotifications.from')"
                            class="required"
                          ></pbas-date-picker>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="3">
                          <pbas-date-picker
                            :value="selectedItem.To"
                            @update-date="selectedItem.To = $event"
                            :rules="[ $rules.required ]"
                            :label="$t('views.portalnotifications.to')"
                            class="required"
                          ></pbas-date-picker>
                        </v-col>
                      </template>
                    </template>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn :disabled="saving" text @click="close()">
                {{
                $t("globals.cancel")
                }}
              </v-btn>
              <v-btn
                :loading="saving"
                :disabled="!valid"
                color="primary"
                @click="save()"
              >{{ $t("globals.save") }}</v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
      </v-row>
    </v-container>
    <material-card
    :title="$t('components.portal.plan_notifications')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="announcement"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :floatActions="floatActions"
        :rowActions="rowActions"
        fileNamePrefix="portal_notifications"
        :sortBy="'Name'"
        :sortDescending="true"
        identifier="portal_notifications"
        @error="error=$event"
      ></pbas-data-table>

      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{$t(message)}}
        <v-btn dark text @click="snackbar = false">{{$t('globals.close')}}</v-btn>
      </v-snackbar>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import NotificationsHeaders from "../headers/Notifications";
import ErrorHandler from "../components/ErrorHandler";
import { locker } from "../mixins/locker";
import TransTexteditor from "../components/TransTexteditor";
import TransSelect from "../components/TransSelect";
import store from "@/store";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import { portalPermission } from "../mixins/portalPermission";

export default {
  components: {
    ErrorHandler,
    TransSelect,
    TransTexteditor,
    NoAutocompleteTextfield
  },
  mixins: [locker, planSetter, portalPermission],
  data() {
    return {
      valid: true,
      selectedItem: null,
      error: null,
      statuses: [],
      periods: [],
      types: [],
      dialogs: {
        edit: false,
        activate: false,
        deactivate: false
      },
      saving: false,
      provider: undefined,
      isNew: false,
      floatActions: [
        {
          name: "add",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            const languages = store.getters["common/languages"];
            this.isNew = true;
            this.selectedItem = {
              PlanId: this.selectedPlan.Id,
              Translations: []
            };
            for (var l of languages) {
              this.selectedItem.Translations.push({
                LanguageCode: l.language,
                // LanguageName: l.title
              });
            }
            this.dialogs.edit = true;
          }
        }
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: async item => {
            // try {
            //   this.selectedItem = await this.lock(
            //     this.getNotificationById,
            //     {
            //       plan: this.selectedPlan.Id,
            //       id: item.Id,
            //       dialogs: this.dialogs,
            //       dialog: "edit"
            //     },
            //     () => {
            //       this.dialogs.edit = false;
            //     }
            //   );
            //   this.isNew = false;
            //   this.dialogs.edit = true;
            // } catch (error) {
            //   this.error = error;
            // }
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.dialogs.edit = true;
          }
        },
        {
          name: "deactivate",
          icon: "toggle_off",
          title: "globals.deactivate",
          handler: async item => {
            // try {
            //   this.selectedItem = await this.lock(
            //     this.getNotificationById,
            //     {
            //       plan: this.selectedPlan.Id,
            //       id: item.Id,
            //       dialogs: this.dialogs,
            //       dialog: "deactivate"
            //     },
            //     () => {
            //       this.dialogs.deactivate = false;
            //     }
            //   );
            //   this.dialogs.deactivate = true;
            // } catch (error) {
            //   this.error = error;
            // }
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.dialogs.deactivate = true;
          },
          visible: item => item.Active
        },
        {
          name: "activate",
          icon: "toggle_on",
          title: "globals.activate",
          handler: async item => {
            // try {
            //   this.selectedItem = await this.lock(
            //     this.getNotificationById,
            //     {
            //       plan: this.selectedPlan.Id,
            //       id: item.Id,
            //       dialogs: this.dialogs,
            //       dialog: "activate"
            //     },
            //     () => {
            //       this.dialogs.activate = false;
            //     }
            //   );
            //   this.dialogs.activate = true;
            // } catch (error) {
            //   this.error = error;
            // }
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.dialogs.activate = true;
          },
          visible: item => !item.Active
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: async item => {
            // try {
            //   this.selectedItem = await this.lock(
            //     this.getNotificationById,
            //     {
            //       id: item.Id,
            //       plan: this.selectedPlan.Id,
            //       dialogs: this.dialogs,
            //       dialog: "delete"
            //     },
            //     () => {
            //       this.dialogs.delete = false;
            //     }
            //   );
            //   this.dialogs.delete = true;
            // } catch (error) {
            //   this.error = error;
            // }
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          }
        }
      ],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: NotificationsHeaders
    };
  },
  computed: {
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    formTitle() {
      return this.isNew
        ? "components.hoursbulktable.create"
        : "globals.edit";
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("downloadCenter", ["saveNotification", "deleteNotification"]),
    async loadPlanData() {
      let url = "cms/odata/Plans(" + this.selectedPlan.Id + ")/Popups";
      this.behaviours = this.columnsDropDownOptions.Models.PopupBehaviours;
      this.periods = this.columnsDropDownOptions.Models.PopupPeriods;
      this.provider = new PbasOData(
        this.$axiosHttp,
        url,
        this.headers
      );
    },
    async save() {
      let item = JSON.parse(JSON.stringify(this.selectedItem));

      item.PopupBehaviourId = item.PopupBehaviour.Id;
      delete item.PopupBehaviour;

      item.PopupPeriodId = item.PopupPeriod.Id;
      delete item.PopupPeriod;

      this.saving = true;
      try {
        await this.saveNotification({
          plan: this.selectedPlan.Id,
          popup: item
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
        
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async activate(active) {
      this.selectedItem.Active = active;
      this.save();
      this.dialogs.deactivate = false;
      this.dialogs.activate = false;
    },
    async tryDelete() {
      this.saving = true;
      try {
        await this.deleteNotification(this.selectedItem.Id);
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.delete = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }

      this.saving = false;
    },
    close() {
      this.selectedItem = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.dialogs.edit = false;
    }
  }
};
</script>


